var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
import { __decorate, __metadata } from "tslib";
import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import store from "@/store/";
// import CryptoJS from 'crypto-js'
let AuthModule = class AuthModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.storage = window.localStorage;
        this.errors = {};
        this.user = {};
        this.isAuthenticated = !!JwtService.getToken();
        this.loginStep = 0;
    }
    /**
     * Get current user object
     * @returns User
     */
    get currentUser() {
        if (!this.user.fullName) {
            let userData = this.storage.getItem('56491f2e1c74898e18bb6e47d2425b19');
            if (JwtService.getToken() && userData) {
                let userLocal = atob(userData);
                if (userLocal)
                    store.dispatch(Actions.SET_USER_ACTION, JSON.parse(userLocal));
            }
        }
        return this.user;
    }
    /**
     * Verify user authentication
     * @returns boolean
     */
    get isUserAuthenticated() {
        return this.isAuthenticated;
    }
    /**
     * Get authentification errors
     * @returns array
     */
    get getErrors() {
        return this.errors;
    }
    get getLoginStep() {
        return this.loginStep;
    }
    [_a = Mutations.SET_LOGIN_STEP](step) {
        this.loginStep = step;
    }
    [_b = Mutations.SET_ERROR](error) {
        this.errors = error;
    }
    [_c = Mutations.SET_AUTH](user) {
        this.isAuthenticated = true;
        this.errors = [];
        this.user = user;
        if (this.storage.getItem('56491f2e1c74898e18bb6e47d2425b19'))
            this.storage.removeItem('56491f2e1c74898e18bb6e47d2425b19');
        let userData = btoa(JSON.stringify(user));
        this.storage.setItem('56491f2e1c74898e18bb6e47d2425b19', userData);
        JwtService.saveToken(this.user.jwtToken);
        ApiService.setHeader();
    }
    [_d = Mutations.SET_AUTH_TOKEN](user) {
        this.isAuthenticated = true;
        this.errors = [];
        this.user = user;
        if (this.storage.getItem('56491f2e1c74898e18bb6e47d2425b19'))
            this.storage.removeItem('56491f2e1c74898e18bb6e47d2425b19');
        let userData = btoa(JSON.stringify(user));
        this.storage.setItem('56491f2e1c74898e18bb6e47d2425b19', userData);
        JwtService.saveToken(this.user.jwtToken);
        ApiService.setHeader();
    }
    [_e = Mutations.SET_USER](user) {
        this.user = user;
    }
    [_f = Mutations.SET_PASSWORD](password) {
        //this.user.password = password;
    }
    [_g = Mutations.PURGE_AUTH]() {
        this.isAuthenticated = false;
        this.user = {};
        this.storage.removeItem('userData');
        this.errors = [];
        JwtService.destroyToken();
    }
    [_h = Actions.SET_LOGIN_STEP_ACTION](step) {
        this.context.commit(Mutations.SET_LOGIN_STEP, step);
    }
    [_j = Actions.SET_USER_ACTION](user) {
        this.context.commit(Mutations.SET_USER, user);
    }
    [_k = Actions.LOGIN](credentials) {
        return new Promise(resolve => {
            const params = Object.assign({}, credentials);
            ApiService.post("login/Authenticate", params)
                .then(({ data }) => {
                if (data.values.token != null) {
                    data.values.token.fullyAuthenticated = false;
                    this.context.commit(Mutations.SET_AUTH, data.values.token);
                    resolve(data);
                }
                else {
                    this.context.commit(Mutations.SET_ERROR, data.values.message);
                    resolve(data);
                }
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
                resolve(false);
            });
        });
    }
    [_l = Actions.AUTHENTICATEUNIDADE](credentials) {
        return new Promise(resolve => {
            const params = Object.assign({}, credentials);
            ApiService.post("login/AuthenticateUnidade", params)
                .then(({ data }) => {
                data.values.fullyAuthenticated = true;
                this.user.fullyAuthenticated = true;
                this.context.commit(Mutations.SET_AUTH_TOKEN, data.values);
                this.context.commit(Mutations.SET_AUTH, this.user);
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_m = Actions.LOGOUT]() {
        this.context.commit(Mutations.PURGE_AUTH);
    }
    [_o = Actions.REGISTER](credentials) {
        return ApiService.post("register", credentials)
            .then(({ data }) => {
            this.context.commit(Mutations.SET_AUTH, data);
        })
            .catch(({ response }) => {
            this.context.commit(Mutations.SET_ERROR, response.data.errors);
        });
    }
    [_p = Actions.FORGOT_PASSWORD](payload) {
        const params = {
            params: Object.assign({}, payload),
        };
        return ApiService.query("forgot_password", params)
            .then(({ data }) => {
            this.context.commit(Mutations.SET_AUTH, data);
        })
            .catch(({ response }) => {
            this.context.commit(Mutations.SET_ERROR, response.data.errors);
        });
    }
    [_q = Actions.VERIFY_AUTH]() {
        // verify authentication        
        if (!this.user.fullName) {
            let userData = this.storage.getItem('56491f2e1c74898e18bb6e47d2425b19');
            if (JwtService.getToken() && userData) {
                let userLocal = atob(userData);
                if (userLocal)
                    this.context.commit(Mutations.SET_USER, JSON.parse(userLocal));
            }
        }
        if (JwtService.getToken() && this.user.fullyAuthenticated) {
            ApiService.setHeader();
            const params = {
                params: {
                    token: JwtService.getToken(),
                },
            };
            ApiService.query("verify_token", params);
        }
        else {
            this.context.commit(Mutations.PURGE_AUTH);
        }
    }
    [_r = Actions.GET_UNITY]() {
        return new Promise(resolve => {
            ApiService.get("Unidade/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _k, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _l, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _m, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _o, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _p, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _q, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _r, null);
AuthModule = __decorate([
    Module
], AuthModule);
export default AuthModule;
//# sourceMappingURL=AuthModule.js.map